export default __webpack_public_path__ + "static/media/34.e389bc3c.jpg";